
<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher une analyse..."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
       <mat-card-subtitle>
  <div class="btn-group rounded-pill" role="group" aria-label="Actions échantillons">

    <!-- 🔹 Bouton principal "Actions" -->
    <div class="btn-group dropdown">
      <button type="button" class="btn btn-outline-primary btn-sm rounded-start-pill"
              style="width:100px"
              data-bs-toggle="dropdown">
        Actions
      </button>

      <ul class="dropdown-menu p-2">
        <div class="row d-flex justify-content-center" style="width: 200px;">

          <!-- Valider les résultats -->
          <div class="col-lg-12">
            <button style="width: 180px"
                    class="btn btn-outline-primary btn-sm my-1"
                    *ngIf="hasAnyRole(['ROLE_RESPONSABLE_LABORATOIRE'])"
                    (click)="openValidationModal(validationModal)"
                    [disabled]="loadingCalBtn">
              <span *ngIf="loadingCalBtn" class="spinner-grow spinner-grow-sm"></span>
              <span class="px-2">{{ loadingCalBtn ? 'Chargement' : 'Valider les résultats' }}</span>
            </button>
          </div>

          <!-- Re-calculer les résultats
          <div class="col-lg-12">
            <button style="width: 170px"
                    class="btn btn-outline-primary btn-sm my-1"
                    (click)="recalculerMultipleResult()"
                    [disabled]="loadingCalBtn">
              <span *ngIf="loadingCalBtn" class="spinner-grow spinner-grow-sm"></span>
              <span class="px-2">{{ loadingCalBtn ? 'Chargement' : 'Re-calculer les résultats' }}</span>
            </button>
          </div>
 -->
          <!-- Réviser les résultats -->
          <div class="col-lg-12">
            <button style="width: 180px"
                    class="btn btn-outline-primary btn-sm my-1"
                    *ngIf="hasRole('ROLE_RESPONSABLE_LABORATOIRE')"
                    (click)="openRevisionModal(revisionModal)"
                    [disabled]="loadingCalBtn">
              <span *ngIf="loadingCalBtn" class="spinner-grow spinner-grow-sm"></span>
              <span class="px-2">{{ loadingCalBtn ? 'Chargement' : 'Réviser les résultats' }}</span>
            </button>
          </div>

          

        </div>
      </ul>
      <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                        aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                    <i class="fa-solid fa-sliders  px-2"></i>
                </button>
    </div>



  </div>
</mat-card-subtitle>

    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">

            <div class="table-responsive">
           <table mat-table [dataSource]="dataSource" matSort >

                    <!-- select Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell
                            *matHeaderCellDef>
                            <mat-checkbox (change)="handleSelectAll()"/>
                        </th>
                        <td mat-cell *matCellDef="let element" style="padding: 20px">
                            <mat-checkbox [checked]="selectedAll" (change)="handleChecked(element)"/>
                        </td>
                    </ng-container>

                    <!-- sampleCode Column -->
                    <ng-container matColumnDef="ref">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Réference</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0" readonly
                                type="text"
                                [value]="element.refAnalyse"
                                (keydown)="navigateInputs($event, i, 'ref')"
                                [id]="'ref' + i"
                            ></td>
                    </ng-container>
                    <ng-container matColumnDef="sampleAnalyseRef">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Réference Intere</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0" readonly
                                type="text"
                                [value]="element.sampleAnalyseRef"
                                (keydown)="navigateInputs($event, i, 'sampleAnalyseRef')"
                                [id]="'sampleAnalyseRef' + i"
                            ></td>
                    </ng-container>

                    <!-- sampleCode Column -->
                    <ng-container matColumnDef="sampleCode">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Échantillion</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0" readonly
                                type="text"
                                [value]="element.sampleCode"
                                (keydown)="navigateInputs($event, i, 'sampleCode')"
                                [id]="'sampleCode' + i"
                            ></td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="formule">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Formule</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0" readonly
                                type="text"
                                [value]="element.formuleName"
                                (keydown)="navigateInputs($event, i, 'formule')"
                                [id]="'formule' + i"
                            ></td>
                    </ng-container> -->
                    <!-- parameter Column -->
                    <ng-container matColumnDef="parameter">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Parametre</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0" readonly
                                type="text"
                                [value]="element.parameterName"
                                (keydown)="navigateInputs($event, i, 'parameter')"
                                [id]="'parameter' + i"
                            ></td>
                    </ng-container>

 

                    <!-- startDate Column -->
                    <ng-container matColumnDef="startDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date début</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input readonly
                                class="form-control border-0"
                                type="datetime-local"
                                [(ngModel)]="element.startDate"
                                (keydown)="navigateInputs($event, i, 'startDate')"
                                [id]="'startDate' + i"
                            ></td>
                    </ng-container>

                    <!-- endDate Column -->
                    <ng-container matColumnDef="endDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date fin</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="datetime-local"
                                [(ngModel)]="element.endDate"
                                (keydown)="navigateInputs($event, i, 'endDate')"
                                (change)="addResult(element)"
                                [id]="'endDate' + i"
                            ></td>
                    </ng-container>
                    <ng-container matColumnDef="lq">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>LQ</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="number"
                                [(ngModel)]="element.lq"
                                (keydown)="navigateInputs($event, i, 'lq')"
                                (change)="addResult(element)"
                                [id]="'lq' + i"
                            ></td>
                    </ng-container>
                    <!--<ng-container matColumnDef="dateMesure">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date de mesure</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="datetime-local"
                                [(ngModel)]="element.dateMesure"
                                (keydown)="navigateInputs($event, i, 'dateMesure')"
                                (change)="addResult(element)"
                                [id]="'dateMesure' + i"
                            ></td>
                    </ng-container>-->

                    <!-- Poids Column -->
                    <ng-container matColumnDef="poids">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Poids</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="number"
                                [(ngModel)]="element.poids"
                                (keydown)="navigateInputs($event, i, 'poids')"
                                (change)="addResult(element)"
                                [id]="'poids' + i">
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="commentaireResult">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Commentaire Résultat</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="text"
                                [(ngModel)]="element.commentaireResult"
                                (keydown)="navigateInputs($event, i, 'commentaireResult')"
                                (change)="addResult(element)"
                                [id]="'commentaireResult' + i">
                        </td>
                    </ng-container>

                    <!-- Resultat Column 
                    <ng-container matColumnDef="resultatBrute">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Résultat brute</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="number"
                                [(ngModel)]="element.resultatBrute"
                                (keydown)="navigateInputs($event, i, 'resultatBrute')"
                                (change)="addResult(element)"
                                [id]="'resultatBrute' + i"
                            >
                        </td>
                    </ng-container>-->

                    <!-- Resultat Column -->
<ng-container matColumnDef="resultatFinale">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Resultat finale</th>

  <td mat-cell *matCellDef="let element; let i = index">

    <!-- CAS 1 : null + NO INTERCEPT → input éditable -->
    <ng-container *ngIf=" element.commentaireResult?.toLowerCase() === 'no intercept'">      
        <div class="d-flex align-items-center gap-1">
        <input
          class="form-control border-1 border-warning"
          type="number"
          [id]="'resultatFinale' + i"
          placeholder="Saisir..."
          style="min-width: 90px; background-color: #fffbe6;"
          (input)="tempValues[element.id] = $any($event.target).value"
          (keydown.enter)="saveManualResult(element, tempValues[element.id])"
        />
        <button
          mat-icon-button
          matTooltip="Enregistrer"
          color="primary"
          (click)="saveManualResult(element, tempValues[element.id])"
          [disabled]="!tempValues[element.id] && tempValues[element.id] !== 0">
          <i class="material-symbols-outlined" style="font-size:18px;">save</i>
        </button>
      </div>
    </ng-container>

    <!-- CAS 2 : null + pas NO INTERCEPT → N/A -->
    <span *ngIf="element.resultatFinale === null && element.commentaireResult !== 'NO INTERCEPT'"
          class="text-muted">
      N/A
    </span>

    <!-- CAS 3 : valeur existante → readonly -->
    <input *ngIf="element.resultatFinale !== null"
           readonly
           class="form-control border-0"
           type="number"
           [ngModel]="element.resultatFinale"
           [id]="'resultatFinale' + i">
  </td>
</ng-container>
                    <!-- Après la colonne resultatFinale, avant action -->
<ng-container matColumnDef="afficherRapport">
  <th mat-header-cell *matHeaderCellDef class="text-center">Rapport</th>
  <td mat-cell *matCellDef="let element" class="text-center">
    
    <!-- Checkbox uniquement si dépasse la LQ -->
    <ng-container>
      <input type="checkbox"
             [(ngModel)]="element.afficherDansRapport"
             (change)="onAfficherRapportChange(element)"
             matTooltip="Afficher dans le rapport" />
    </ng-container>
  </td>
</ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
<!--                                <button type="button" mat-button matTooltip="Sauvegarder" matTooltipPosition="above"-->
<!--                                        (click)="updateAnalyse(element)">-->
<!--                                    <i class="material-symbols-outlined text-primary">-->
<!--                                        check_circle-->
<!--                                    </i>-->
<!--                                </button>-->
                                <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element.id)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns;"
                        [ngClass]="{ 'over-lq-row': isOverLQ(row) }">
                    </tr>


                    <tr class="mat-row" *matNoDataRow>
                        <td *ngIf="!loadingTable" class="mat-cell" colspan="15">Aucun Analyse trouvé pour Analyse</td>
                    </tr>

                </table >
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>

            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>

<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="my-0">
                    Update Analyse
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editForm">
                <div class="row">

                    <!-- refAnalyse -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Reference</mat-label>
                            <input readonly matInput formControlName="refAnalyse" placeholder="Ex. A12345">
                            <mat-error *ngIf="editForm.get('refAnalyse')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- startDate -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Start Date</mat-label>
                            <input matInput readonly [matDatepicker]="picker1" formControlName="startDate"
                                   placeholder="Select start date">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                            <mat-error *ngIf="editForm.get('startDate')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- endDate -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>End Date</mat-label>
                            <input matInput readonly [matDatepicker]="picker2" formControlName="endDate"
                                   placeholder="Select end date">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                            <mat-error *ngIf="editForm.get('endDate')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>


                    <!-- Statut-->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Statut</mat-label>
                            <mat-select formControlName="status" placeholder="Select a client">
                                <mat-option [value]="0">En éxecusion</mat-option>
                                <mat-option [value]="1">Termié</mat-option>
                            </mat-select>
                            <mat-error *ngIf="editForm.get('status')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- sample -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Sample</mat-label>
                            <input matInput readonly formControlName="sampleCode">
                        </mat-form-field>
                    </div>

                    <!-- parameter -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Parametre</mat-label>
                            <input matInput readonly formControlName="parameterName">
                        </mat-form-field>
                    </div>

                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Utilisateurs</mat-label>
                            <mat-select formControlName="userId" placeholder="Select a client">
                                <mat-option *ngFor="let user of userList" [value]="user.id">
                                    {{ user.username }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('clientId')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>


                    <!-- poids -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Poids</mat-label>
                            <input type="number" matInput formControlName="poids">
                            <mat-error *ngIf="editForm.get('poids')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!--                     resultat -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Resultat
                            </mat-label>
                            <input type="number" matInput formControlName="resultat">
                            <mat-error *ngIf="editForm.get('resultat')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- resultatFinale -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Resultat finale</mat-label>
                            <input type="number" matInput formControlName="resultatFinale">
                            <mat-error *ngIf="editForm.get('resultatFinale')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- commentaire -->
                    <div class="col-sm-8">
                        <mat-form-field class="mb-25">
                            <mat-label>Comment</mat-label>
                            <textarea matInput formControlName="commentaire" placeholder="Enter comment"></textarea>
                            <mat-error *ngIf="editForm.get('commentaire')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-outline-success">Enregistrer</button>
                    </div>

                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-content>
            <div class="row">
                <h5 class="px-3 fw-bolder text-secondary">Détails analyse :</h5>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Nom du paramètre :</div>
                    <p>{{ analyse?.parameterName }}</p>
                </div>

                <!-- Analyse Reference -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Référence Analyse :</div>
                    <p>{{ analyse?.refAnalyse }}</p>
                </div>

                <!-- Sample Details -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Code Échantillon :</div>
                    <p>{{ analyse?.sampleCode }}</p>
                </div>

                <!-- Analysis Dates -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Date de Début :</div>
                    <p>{{ analyse?.startDate | date : "short" }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Date de Fin :</div>
                    <p>{{ analyse?.endDate | date : "short" }}</p>
                </div>

                <!-- Status -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Statut :</div>
                    <p>{{ analyse?.status ? "Termié" : "En éxecusion" }}</p>
                </div>

                <!-- Creation and Update Dates -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Créé le :</div>
                    <p>{{ analyse?.creationDate | date : "short" }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Modifié le :</div>
                    <p>{{ analyse?.updateDate | date : "short" }}</p>
                </div>

                <!-- Created By -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Créateur :</div>
                    <p>{{ analyse?.appUserName }}</p>
                </div>

                <!-- Poids -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Poids :</div>
                    <p>{{ analyse?.poids }} Kg</p>
                </div>

                <!-- resultat -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Resultat :</div>
                    <p>{{ analyse?.resultatBrute }}</p>
                </div>

                <!-- resultatFinale -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Resultat Finale :</div>
                    <p>{{ analyse?.resultatFinale }}</p>
                </div>


                <!-- Comment -->
                <div class="col-sm-6 col-lg-8 border-top p-3">
                    <div class="fw-bold">Commentaire :</div>
                    <p>{{ analyse?.commentaire }}</p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>
<ng-template #validationModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Valider les résultats</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th scope="col">
            <input type="checkbox" [(ngModel)]="selectAll" (change)="toggleAll()">
          </th>
          <th scope="col">Réference interne</th>
          <th scope="col">Statut</th>
          <th scope="col">Date Analyse</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sample of calculableSamples">
          <td><input type="checkbox" [(ngModel)]="sample.selected"></td>
          <td>{{ sample.referenceInterne }}</td>
          <td>{{ sample.statut }} ({{ sample.resultsCount }} analyse{{ sample.resultsCount > 1 ? 's' : '' }})</td>
          <td>{{ sample.dateAnalyse | date:'shortDate' }}</td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="calculableSamples.length === 0">Aucun échantillon avec des résultats calculés.</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Annuler</button>
    
    <!-- 🔹 Bouton "Valider" selon le rôle 
    <button 
      type="button" 
      class="btn btn-success"
      [disabled]="!hasSelectedSamples()"
      (click)="
        currentUserRole === 'ROLE_SAMPLERS' 
          ? validateSelectedSamplesByTechnicien(modal) 
          : validateSelectedSamplesByRespQualite(modal)
      ">
      Valider
    </button>-->
    <button 
        type="button" 
        class="btn btn-success"
        [disabled]="!hasSelectedSamples()"
        (click)="validateSelectedSamplesByRespQualite(modal)">
        Valider
    </button>
  </div>
</ng-template>

<ng-template #revisionModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Réviser les résultats</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th scope="col">
            <input type="checkbox" [(ngModel)]="selectAllRevision" (change)="toggleAllRevision()">
          </th>
          <th scope="col">Réference interne</th>
          <th scope="col">Statut</th>
          <th scope="col">Date Analyse</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sample of revisableSamples">
          <td><input type="checkbox" [(ngModel)]="sample.selected"></td>
          <td>{{ sample.referenceInterne }}</td>
          <td>{{ sample.statut }} ({{ sample.resultsCount }} analyse{{ sample.resultsCount > 1 ? 's' : '' }})</td>
          <td>{{ sample.dateAnalyse | date:'shortDate' }}</td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="revisableSamples.length === 0">Aucun échantillon à réviser.</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Annuler</button>
    <button 
      type="button" 
      class="btn btn-primary"
      [disabled]="!hasSelectedRevisableSamples()"
      (click)="reviserSelectedSamples(modal)">
      Réviser
    </button>
  </div>
</ng-template>

<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ columnLabels[col] || col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>


<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>